var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChordRecognition = function SvgChordRecognition(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 23"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.41 18.32H3.75c-.42 0-.75-.34-.75-.75V5.55c0-.42.34-.75.75-.75h6.66v1H4v5.48h5.55v1H4v5.05h6.41v1zm3.26-2.17c-.19 0-.37-.07-.51-.2a.74.74 0 0 1-.23-.54V4h1v5.35c1.15-1.34 3.01-1.44 3.99-.24.63.77.89 1.95.67 3.06-.45 2.22-2.45 3.86-4.88 3.98zm.26-3.95v2.93c1.84-.2 3.34-1.46 3.68-3.15.16-.82-.02-1.69-.46-2.23q-.42-.51-1.02-.51c-.9 0-2.19 1.06-2.19 2.97z"
  })));
};
export default SvgChordRecognition;